import React from "react";
import PropTypes from "prop-types";
import { TableRow, Checkbox } from "@mui/material";
import { Autocomplete, TextField } from "@totalsoft/rocket-ui";
import { DenseBodyCell } from "components/common/TableStyles";

export const ScoringDimensionPeriodItemComponent = ({
  onPeriodDimensionChange,
  document,
  validationInfo,
  disabled,
  dimensions
}) => {
  const handlePropertyChange = prop => e => {
    switch (prop) {
      case "selected": {
        onPeriodDimensionChange(prop, e.target.checked);
        break;
      }
      case "dimensionPeriodYear":
      case "dimensionPeriodMonth": {
        onPeriodDimensionChange(prop, e.target.value);
        break;
      }
      case "dimensionId": {
        onPeriodDimensionChange(prop, e.target.value);
        break;
      }
      default:
        break;
    }
  };

  return (
    <TableRow>
      <DenseBodyCell sx={{ width: "10%" }}>
        <Checkbox checked={document.selected} onChange={handlePropertyChange("selected")} />
      </DenseBodyCell>
      <DenseBodyCell>
        <TextField
          fullWidth
          value={document.dimensionPeriodYear || ""}
          error={validationInfo.dimensionPeriodYear ? true : false}
          onChange={handlePropertyChange("dimensionPeriodYear")}
          disabled={disabled}
        />
      </DenseBodyCell>
      <DenseBodyCell>
        <TextField
          fullWidth
          value={document.dimensionPeriodMonth || ""}
          error={validationInfo.dimensionPeriodMonth ? true : false}
          onChange={handlePropertyChange("dimensionPeriodMonth")}
          disabled={disabled}
        />
      </DenseBodyCell>
      <DenseBodyCell>{document.dimensionPeriodName}</DenseBodyCell>
      <DenseBodyCell>
        <Autocomplete
          disabled={disabled}
          fullWidth
          value={document.dimensionId}
          valueKey="id"
          options={dimensions}
          onChange={handlePropertyChange("dimensionId")}
          clearable={false}
          simpleValue={true}
          name="dimensionId"
        />
      </DenseBodyCell>
      <DenseBodyCell>{document.dimensionPeriodSourceName}</DenseBodyCell>
    </TableRow>
  );
};

ScoringDimensionPeriodItemComponent.propTypes = {
  onPeriodDimensionChange: PropTypes.func.isRequired,
  document: PropTypes.object.isRequired,
  validationInfo: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  dimensions: PropTypes.array.isRequired
};

export default ScoringDimensionPeriodItemComponent;
